import * as React from 'react';

import { PageContent } from '../../components/common';
import { SectionMain } from '../../components/sections';
import WorkflowProgress from '../WorkflowProgress';
import SimpleAboutYouPage from './SimpleAboutYouPage';
import SimpleSelectYourPlanPage from './SimpleSelectYourPlanPage';
import EnrollmentPage from '../enrollment/EnrollmentPage';

interface Props {
	user: UserDetails;
	customerDetails: CustomerDemographicDetails;
	saveAndRedirect: (url: string) => void;
	history: any;
	match: any;
}
const SimpleWorkflow: React.StatelessComponent<Props> = props => {
	let Page: any | null = null;
	let activeStep = 0;

	if (props.match.params.page === 'about-you') {
		Page = SimpleAboutYouPage;
		activeStep = 0;
	} else if (props.match.params.page === 'select-your-policy') {
		Page = SimpleSelectYourPlanPage;
		activeStep = 1;
	} else if (props.match.params.page === 'enrollment') {
		Page = EnrollmentPage;
		if (props.match.params.enrollmentPage === 'billing'
			|| props.match.params.enrollmentPage === 'review'
			|| props.match.params.enrollmentPage === 'beneficiary'
			|| props.match.params.enrollmentPage === 'sign-up') {
			activeStep = 3;
		} else {
			activeStep = 2;
		}
	} else if (props.match.params.page == null) {
		if (props.customerDetails.age != null
			&& props.user.gender != null
			&& props.customerDetails.isSmoker != null) {
			props.history.replace(`/quote/${props.match.params.workflow}/select-your-policy`);
		} else {
			props.history.replace(`/quote/${props.match.params.workflow}/about-you`);
		}
	}

	return (
		<div>
			<PageContent wrapperClassName="mt-6" sectionClassName="pt-0">
				<SectionMain
					sectionClassName="section-sm section-extend-up bg-secondary text-light workflow-progress-wrapper"
					wrapperClassName="mb-4 mb-md-5 px-0"
				>
					<WorkflowProgress
						buttonClassName="btn-outline-light"
						steps={[
							{
								label: 'About you',
								to: `/quote/${props.match.params.workflow}/about-you`,
								incomplete: Page === EnrollmentPage && activeStep === 3
							},
							{
								label: 'Select your policy',
								to: `/quote/${props.match.params.workflow}/select-your-policy`,
								incomplete: Page === EnrollmentPage && activeStep === 3
							},
							{
								label: 'Apply for coverage',
								onClick: () => props.saveAndRedirect(`/quote/${props.match.params.workflow}/enrollment/my-pledge`),
								incomplete: Page === EnrollmentPage && activeStep === 3
							},
							{
								label: 'Review and billing',
								onClick: () => props.saveAndRedirect(`/quote/${props.match.params.workflow}/enrollment/review`),
								incomplete: Page === EnrollmentPage && activeStep === 3
							}
						]}
						activeStep={activeStep}
					/>
				</SectionMain>
				{Page !== null && <Page {...props} />}
			</PageContent>
		</div>
	);
};

export default SimpleWorkflow;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/simple/SimpleWorkflow.tsx